<div (click)="onClick()" class="feedback" #feedback i18n="@@app.lets_discuss">Feedback</div>

